import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'app-filter-v2-buttons',
  templateUrl: './filter-v2-buttons.component.html',
  styleUrls: ['./filter-v2-buttons.component.scss'],
})
export class FilterV2ButtonsComponent {
  @Input() mobile = false;
  @Input() position: 'center' | 'right' = 'center';
  @Output() resetAction = new EventEmitter();
  @Output() applyAction = new EventEmitter();

  handleReset(button: ButtonComponent): void {
    button.blurButton();
    this.resetAction.emit();
  }

  handleApply(button: ButtonComponent): void {
    button.blurButton();
    this.applyAction.emit();
  }
}
